import script from "./bindingDevice.vue?vue&type=script&setup=true&lang=ts"
export * from "./bindingDevice.vue?vue&type=script&setup=true&lang=ts"

import "./bindingDevice.vue?vue&type=style&index=0&id=471b43cd&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-471b43cd"]])

export default __exports__